// RISE is VA's post-realignment numbering (stations.new_visn). One RISE
// owns many legacy VISNs (stations.visn). Engagement uses these for the
// By RISE tab, the parent RisePill, and station identity headers.

export const UNASSIGNED_RISE = "Unassigned";

export const formatRiseLabel = (n) => {
  if (n == null || n === "" || n === UNASSIGNED_RISE) return UNASSIGNED_RISE;
  return `RISE ${n}`;
};

// Station 619 (VISN 8) (RISE 2) — omit a parenthetical when that value is missing.
export const formatStationIdentity = ({ station_id, visn, new_visn } = {}) => {
  const id = station_id == null || station_id === "" ? "" : String(station_id);
  const parts = [`Station ${id}`.trim()];
  if (visn != null && visn !== "") parts.push(`(VISN ${visn})`);
  if (new_visn != null && new_visn !== "") parts.push(`(RISE ${new_visn})`);
  return parts.join(" ");
};

const sortNumericStrings = (values) =>
  [...values].sort((a, b) => Number(a) - Number(b) || String(a).localeCompare(String(b), undefined, { numeric: true }));

// Distinct legacy VISNs under the selected RISE(s). Empty riseFilters → every
// VISN on the station list (same as today's unscoped pill).
export const visnsForRise = (stations, riseFilters) => {
  const riseSet = new Set((riseFilters || []).map(String));
  const visns = new Set();
  (stations || []).forEach((s) => {
    if (s.visn == null || s.visn === "") return;
    if (riseSet.size === 0 || (s.new_visn != null && riseSet.has(String(s.new_visn)))) {
      visns.add(String(s.visn));
    }
  });
  return sortNumericStrings(visns);
};

export const pruneVisnFilters = (visnFilters, allowedVisns) => {
  const allowed = new Set((allowedVisns || []).map(String));
  return (visnFilters || []).filter((v) => allowed.has(String(v)));
};

export const distinctRiseNumbers = (stations) => {
  const rises = new Set();
  (stations || []).forEach((s) => {
    if (s.new_visn != null && s.new_visn !== "") rises.add(String(s.new_visn));
  });
  return sortNumericStrings(rises);
};

export const riseGroupKey = (new_visn) =>
  (new_visn == null || new_visn === "" ? UNASSIGNED_RISE : String(new_visn));

export const groupStationsByRise = (stations, { licenseCount, activeCount } = {}) => {
  const lic = licenseCount || ((s) => s.licensed_to_date ?? s.activated_to_date ?? 0);
  const act = activeCount || ((s) => s.activated_to_date ?? 0);
  const acc = {};
  (stations || []).forEach((s) => {
    const k = riseGroupKey(s.new_visn);
    if (!acc[k]) {
      acc[k] = {
        rise: formatRiseLabel(k === UNASSIGNED_RISE ? null : k),
        riseKey: k,
        visns: new Set(),
        stations: 0,
        activeStations: 0,
        licensed: 0,
        activated: 0,
      };
    }
    if (s.visn != null && s.visn !== "") acc[k].visns.add(String(s.visn));
    acc[k].stations++;
    if (act(s) > 0) acc[k].activeStations++;
    acc[k].licensed += lic(s);
    acc[k].activated += act(s);
  });
  return Object.values(acc).map((row) => ({
    ...row,
    visns: sortNumericStrings(row.visns),
  }));
};
